import { __ } from '@wordpress/i18n';

export const types = [
	{ label: __('Line', 'chart-block'), value: 'line' },
	{ label: __('Bar', 'chart-block'), value: 'bar' },
	{ label: __('Pie', 'chart-block'), value: 'pie' },
	{ label: __('Radar', 'chart-block'), value: 'radar' },
	{ label: __('Doughnut', 'chart-block'), value: 'doughnut' },
	{ label: __('Polar Area', 'chart-block'), value: 'polarArea' },
];

export const pointStyles = [
	{ label: __('Circle', 'chart-block'), value: 'circle' },
	{ label: __('Cross', 'chart-block'), value: 'cross' },
	{ label: __('Cross Rot', 'chart-block'), value: 'crossRot' },
	{ label: __('Dash', 'chart-block'), value: 'dash' },
	{ label: __('Line', 'chart-block'), value: 'line' },
	{ label: __('Rect', 'chart-block'), value: 'rect' },
	{ label: __('Rect Rounded', 'chart-block'), value: 'rectRounded' },
	{ label: __('Rect Rot', 'chart-block'), value: 'rectRot' },
	{ label: __('Star', 'chart-block'), value: 'star' },
	{ label: __('Triangle', 'chart-block'), value: 'triangle' },
];